function GetCompanyCardPrice() {

    var Amount = $("#ForMemberCardAmount").val();
    var OldAmount = $("#ForMemberCardOldAmount").val();
    var MemberCardGroupID = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode = $("#ForMemberCardCurrencySymbol").val();

    if (Amount != undefined &&
        OldAmount != undefined &&
        MemberCardGroupID != undefined &&
        ForMemberCardCurrencyCode != undefined &&
        MemberCardGroupID != -1) {
        $.ajax({
            type: 'get',
            url: getRequestRoute() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount + "&AmountOld=" + OldAmount + "&MemberCardGroupID=" + MemberCardGroupID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {

                    $(".RPrice").html(ForMemberCardCurrencyCode + " " + dt.TotalAmount);

                    $(".CompanyCardPrice").css("display", "inline-block");
                }
            }
        });
    }
}

// Mini Basket Style
function hideBasket() {
    $(".js-mini-cart").removeClass("opened");
    backdropControl("hide");
}

function toggleBasket() {
    if ($(".js-mini-cart").hasClass("opened")) {
        hideBasket();
    }
    else {
        $(".js-mini-cart").addClass("opened");
        backdropControl("show");
    }
}
// End Mini Basket Style

function GetSepetIcerik(openBasket) {
    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/Cart/GetSepetIcerik",
        data: "",
        async: true,
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: 'text',
        success: function (dt) {
            $(".js-user-navigation").html(dt);

            if (openBasket)
                toggleBasket()
        }
    });
}
// End Mini Basket Operations

// Product List

// End Product List

// Product Detail
function AddToCard(param, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToCart",
        data: param,
        dataType: 'json',
        async: true,
        success: function (dt) {
            //if (dt.JsonRs != null && dt.JsonRs != undefined && dt.JsonRs != "") {
            //    window.dataLayer = window.dataLayer || [];
            //    dataLayer.push({
            //        "event": "eec.add",
            //        "ecommerce": {
            //            "add": {
            //                "actionField": {
            //                    "list": "Product Detail"
            //                },
            //                "products": [JSON.parse(dt.JsonRs)]
            //            }
            //        }
            //    });
            //}

            callback(dt);
        }
    });
}
// Product Detail

// Combine
function AddCombineToBasket(basketButton, NormalText, data) {
    GenerateLocalLoading($(".ProductDetail.Combines"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddCombineToCart",
        data: data,
        dataType: 'json',
        async: true,
        success: function (dt) {
            basketButton.text(NormalText);

            if (dt.Sonuc == true) {
                GetSepetIcerik(true);
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }

            GenerateLocalLoading($(".ProductDetail.Combines"), "hide");
        }
    });
}
// End Combine